import { makeStyles } from '@material-ui/core/styles';

export const useChatStyles = makeStyles((theme) => ({
  whatsappContainer: {
    display: 'flex',
    height: 'calc(100vh - 160px)', // Resta el espacio del Header y Footer dinámicamente
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    boxShadow: '0 1px 1px 0 rgba(0,0,0,.06), 0 2px 5px 0 rgba(0,0,0,.2)',
    overflow: 'hidden',
  },
  phoneSubtitle: {
    fontFamily: 'MavenProRegular, sans-serif',
    fontSize: '12px',
    color: '#667781',
    marginTop: '2px',
  },
  
  // --- PANEL IZQUIERDO (SIDEBAR) ---
  sidebar: {
    width: '350px',
    borderRight: '1px solid #ff4400',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
  },
  sidebarHeader: {
    backgroundColor: '#e33f04',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    height: '59px',
  },
  searchContactBar: {
    backgroundColor: '#ffffff',
    padding: '8px 12px',
    borderBottom: '1px solid #f0f2f5',
    display: 'flex',
    alignItems: 'center',
  },
  searchField: {
    backgroundColor: '#f0f2f5',
    borderRadius: '8px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      paddingLeft: '8px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 8px 8px 0px',
      fontSize: '13px',
    },
  },
  chatList: {
    flexGrow: 1,
    overflowY: 'auto',
  },
  chatItem: {
    padding: '12px 16px',
    borderBottom: '1px solid #f2f2f2',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#f4571f',
    },
  },
  activeChatItem: {
    backgroundColor: '#ff4400',
    '&:hover': {
      backgroundColor: '#ff4400',
    },
  },
  sidebarAvatar: {
    backgroundColor: '#dfe5e7',
    color: '#54656f',
    fontFamily: 'MavenProBold, sans-serif',
    fontWeight: 700,
    width: '49px',
    height: '49px',
  },

  // --- PANEL DERECHO (VENTANA DE CONVERSACIÓN) ---
  chatWindow: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#efeae2',
    position: 'relative',
  },
  windowHeader: {
    backgroundColor: '#eeeeee',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '59px',
    borderBottom: '1px solid #e0e0e0',
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  messageArea: {
    flexGrow: 1,
    padding: '20px 40px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  
  // BURBUJAS
  messageBubble: {
    padding: '8px 12px',
    borderRadius: '7.5px',
    maxWidth: '65%',
    fontFamily: 'MavenProRegular, sans-serif',
    fontSize: '14px',
    position: 'relative',
    boxShadow: '0 1px 0.5px rgba(0,0,0,.13)',
    wordBreak: 'break-word',
  },
  sentMessage: {
    backgroundColor: '#d9fdd3',
    alignSelf: 'flex-end',
  },
  receivedMessage: {
    backgroundColor: '#ffffff',
    alignSelf: 'flex-start',
  },
  messageTime: {
    fontSize: '10px',
    color: '#667781',
    textAlign: 'right',
    marginTop: '4px',
  },

  // INPUT INFERIOR
  inputArea: {
    backgroundColor: '#f0f2f5',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  inputField: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  
  // ESTADO VACÍO CENTRADO
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    padding: '20px',
  },

  hiddenInputFile: {
    display: 'none',
  },
  fileBubbleContent: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    padding: '8px 12px',
    borderRadius: '6px',
    gap: '10px',
    marginBottom: '4px',
    cursor: 'pointer',
  },
  fileNameText: {
    fontFamily: 'MavenProBold, sans-serif',
    fontWeight: 700,
    fontSize: '13px',
    color: '#111b21',
    maxWidth: '180px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  previewOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#efeae2', // Mismo fondo del chat para dar continuidad
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  previewHeader: {
    backgroundColor: '#eeeeee',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    height: '59px',
    borderBottom: '1px solid #e0e0e0',
  },
  previewBody: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
  },
  previewImage: {
    maxWidth: '80%',
    maxHeight: '300px',
    borderRadius: '4px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
  },
  previewFileBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    padding: '30px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  previewFooter: {
    backgroundColor: '#f0f2f5',
    padding: '24px 32px', // Aumentamos el padding para darle un margen interno excelente a los botones
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px', // Incrementa la separación horizontal entre "Cancelar" y "Enviar"
  },
  
  // Opcional: Si quieres un margen extra exclusivo para el botón de enviar
  btnEnviarDocumento: {
    backgroundColor: '#ff4400',
    color: '#ffffff',
    fontFamily: 'MavenProBold, sans-serif',
    fontWeight: 700,
    marginLeft: theme.spacing(2), // Añade un margen izquierdo usando tu base de espaciado (4px)
    padding: '8px 16px',          // Hace el botón ligeramente más robusto y elegante
    '&:hover': {
      backgroundColor: '#cc3600', // Un tono más oscuro al pasar el cursor para mejorar la UX
    }
  },
}));